// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"Flex_flexRow__kOgOd","flexCol":"Flex_flexCol__efiyP"};